import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

export const init = () => {
    if (process.env.NODE_ENV === 'production') {
        Raven
            .config('https://046e7f482d2b42d1a1e33785cc6a26ae@sentry.io/291396')
            .addPlugin(RavenVue, Vue)
            .install()
    }
}

export const setMember = (member) => {
    if (process.env.NODE_ENV === 'production') {
        if (member !== null && typeof member.email !== 'undefined')
            Raven.setUserContext({
                id: member.id,
                name: member.full_name,
                email: member.email,
            })
    }
}

export default {
    init,
    setMember
}




// WEBPACK FOOTER //
// ./src/assets/vendor/sentry.js